export const environment = {
  adobeLaunchScriptSource:
    'https://assets.adobedtm.com/267c22ecc15c/514441733727/launch-8d90509f3f0c-development.min.js',
  production: false,
  showProvenueErrorInfo: true,
  bypassCheckout: false,
  apiUrl: 'https://dev-groupsales.service.3ddigitalvenue.com/api',
  oktaData: {
    clientId: '0oa1jbndylhbtMYt30h8',
    issuer: 'https://qa-ids.mlb.com/oauth2/ausg0y0s07iKGqVKv0h7',
  },
  analytics: {
    club: [],
    mmc: '',
  },
  // DEV only: allows ?load-mock-client-name to override the hostname club and
  // auto-loads this sandbox tenant when the domain resolves no known club.
  sandboxClient: 'giants' as string | null,
};
